import { useMemo } from "react";
import { useDuplicateSelectedElements } from "@/components/Canvas/hooks/useCopyPaste";
import { useKeyboardShortcuts } from "../core/useKeyboardShortcuts";
import { ShortcutMap } from "../core/types";

export const useDuplicateShortcut = () => {
  const duplicateSelectedElements = useDuplicateSelectedElements();

  const shortcuts: ShortcutMap = useMemo(
    () => ({
      "mod+d": {
        handler: duplicateSelectedElements,
        description: "Duplicate selected element",
      },
    }),
    [duplicateSelectedElements],
  );

  useKeyboardShortcuts({ shortcuts });
};
